var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("table", { staticClass: "table table-hover table-sm" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.records, function (r, i) {
          return _c("tr", [
            _c("td", [
              _vm._v(
                _vm._s(
                  i + 1 + ((_vm.currentPage ?? 1) - 1) * (_vm.perPage ?? 50)
                )
              ),
            ]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(r.drug_id))]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(r.title))]),
            _vm._v(" "),
            _c("td", [
              _vm._v(_vm._s(_vm.allCountries[r.income_country_id]?.name)),
            ]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(r.total_qty))]),
            _vm._v(" "),
            _c("td", [
              _vm._v(_vm._s(Math.round(r.total_qty / +(_vm.days ?? 1)))),
            ]),
          ])
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("#")]),
        _vm._v(" "),
        _c("th", [_vm._v("ID")]),
        _vm._v(" "),
        _c("th", [_vm._v("препарат")]),
        _vm._v(" "),
        _c("th", [_vm._v("страна")]),
        _vm._v(" "),
        _c("th", [_vm._v("всего")]),
        _vm._v(" "),
        _c("th", [_vm._v("в день")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }